import { N as push, Q as spread_props, R as bind_props, P as pop, S as getContext, T as spread_attributes, V as clsx, W as attr, X as ensure_array_like, Y as escape_html, O as setContext, Z as copy_payload, _ as assign_payload, $ as store_get, a0 as stringify, a1 as unsubscribe_stores, a2 as head, a3 as slot } from "../../chunks/index.js";
import { D as DownloadButton } from "../../chunks/DownloadButton.js";
import { P as PurchaseButton, R as Ripple, d as dispatch, S as SvelteEventManager, L as List, I as Item } from "../../chunks/PurchaseButton.js";
import { L as Link } from "../../chunks/Link.js";
import Icon from "../../chunks/icon3.js";
import { A as Animate } from "../../chunks/Animate.js";
import { o as onDestroy } from "../../chunks/index-server.js";
import { c as classMap, S as SmuiElement } from "../../chunks/SmuiElement.js";
import "clsx";
import { C as ClassAdder } from "../../chunks/ClassAdder.js";
import { S as Separator } from "../../chunks/Separator.js";
import { p as page } from "../../chunks/stores.js";
import { a as analytics } from "../../chunks/analytics.js";
import { a as PUBLIC_INSTALLER_NAME } from "../../chunks/public.js";
import { g as goto } from "../../chunks/client.js";
const downloadInstaller = () => {
  analytics.track("download", { platform: "windows", version: "latest" });
  const link = document.createElement("a");
  link.href = "/releases/latest/glimmr-setup.exe";
  link.download = PUBLIC_INSTALLER_NAME;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
function Text($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-deprecated-list-item__text",
      tag: "span"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Graphic($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let menuSelectionGroup = getContext("SMUI:list:graphic:menu-selection-group");
  function getElement() {
    return element;
  }
  $$payload.out += `<span${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-deprecated-list-item__graphic": true,
      "mdc-menu__selection-group-icon": menuSelectionGroup
    })),
    ...restProps
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></span>`;
  bind_props($$props, { getElement });
  pop();
}
const menu = [
  {
    name: "Features",
    link: "/features",
    icon: "star"
  },
  {
    name: "Pricing",
    link: "/pricing",
    icon: "sell"
  },
  {
    name: "Support",
    link: "/support",
    icon: "support"
  }
];
function Logo($$payload) {
  $$payload.out += `<a href="/" class="flex items-center space-x-2 !text-inherit"><img${attr("src", Icon)} class="w-12 h-12 min-w-12 lg:w-8 lg:h-8 lg:min-w-8" alt="logo"> <span class="text-2xl font-display font-bold hidden lg:flex">Glimmr</span></a>`;
}
function Footer($$payload, $$props) {
  push();
  const each_array = ensure_array_like(menu);
  $$payload.out += `<footer class="w-full py-12 md:py-24 bg-teal-950 text-white z-10 flex flex-col items-center"><div class="w-full lg:container mx-auto px-4 relative text-center flex flex-col gap-12"><div class="flex flex-col items-center gap-12 lg:gap-24 md:flex-row md:items-start justify-center mx-auto">`;
  Logo($$payload);
  $$payload.out += `<!----> <div class="flex gap-4 md:gap-8 lg:gap-12"><div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Directory</p> <!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let { name, link } = each_array[i];
    Link($$payload, {
      to: link,
      children: ($$payload2) => {
        $$payload2.out += `<!---->${escape_html(name)}`;
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div> <div class="flex flex-col items-start gap-4"><p class="font-display uppercase opacity-70 text-xs">Contact</p> `;
  Link($$payload, {
    to: "mailto:support@glimmr.app",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Email us`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></div> <div class="flex flex-col xl:flex-row gap-2">`;
  DownloadButton($$payload, { size: 4, background: "dark" });
  $$payload.out += `<!----> `;
  PurchaseButton($$payload, {
    context: "footer",
    size: 4,
    background: "dark"
  });
  $$payload.out += `<!----></div></div> <div class="flex flex-col gap-4 items-center">`;
  Link($$payload, {
    to: "/privacy",
    children: ($$payload2) => {
      $$payload2.out += `<!---->Privacy Policy`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> <p class="font-display opacity-70">© ${escape_html((/* @__PURE__ */ new Date()).getFullYear())} Glimmr LLC / All rights reserved.</p></div></div></footer>`;
  pop();
}
function IconButton($$payload, $$props) {
  push();
  let uninitializedValue = () => {
  };
  function isUninitializedValue(value) {
    return value === uninitializedValue;
  }
  let {
    use = [],
    class: className = "",
    style = "",
    ripple = true,
    color,
    toggle = false,
    pressed = uninitializedValue,
    ariaLabelOn,
    ariaLabelOff,
    touch = false,
    displayFlex = true,
    size = "normal",
    href,
    action,
    component: MyComponent = SmuiElement,
    tag = href == null ? "button" : "a",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let internalStyles = {};
  let internalAttrs = {};
  let context = getContext("SMUI:icon-button:context");
  let ariaDescribedby = getContext("SMUI:icon-button:aria-describedby");
  const actionProp = (() => {
    if (context === "data-table:pagination") {
      switch (action) {
        case "first-page":
          return { "data-first-page": "true" };
        case "prev-page":
          return { "data-prev-page": "true" };
        case "next-page":
          return { "data-next-page": "true" };
        case "last-page":
          return { "data-last-page": "true" };
        default:
          return { "data-action": "true" };
      }
    } else if (context === "dialog:header" || context === "dialog:sheet") {
      return { "data-mdc-dialog-action": action };
    } else {
      return { action };
    }
  })();
  !!restProps.disabled;
  setContext("SMUI:icon:context", "icon-button");
  onDestroy(() => {
  });
  function addClass(className2) {
    if (!internalClasses[className2]) {
      internalClasses[className2] = true;
    }
  }
  function removeClass(className2) {
    if (!(className2 in internalClasses) || internalClasses[className2]) {
      internalClasses[className2] = false;
    }
  }
  function addStyle(name, value) {
    if (internalStyles[name] != value) {
      if (value === "" || value == null) {
        delete internalStyles[name];
      } else {
        internalStyles[name] = value;
      }
    }
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use: [
        [
          Ripple,
          {
            ripple,
            unbounded: true,
            color,
            disabled: !!restProps.disabled,
            addClass,
            removeClass,
            addStyle
          }
        ],
        ...use
      ],
      class: classMap({
        [className]: true,
        "mdc-icon-button": true,
        "mdc-icon-button--on": !isUninitializedValue(pressed) && pressed,
        "mdc-icon-button--touch": touch,
        "mdc-icon-button--display-flex": displayFlex,
        "smui-icon-button--size-button": size === "button",
        "smui-icon-button--size-mini": size === "mini",
        "mdc-icon-button--reduced-size": size === "mini" || size === "button",
        "mdc-card__action": context === "card:action",
        "mdc-card__action--icon": context === "card:action",
        "mdc-top-app-bar__navigation-icon": context === "top-app-bar:navigation",
        "mdc-top-app-bar__action-item": context === "top-app-bar:action",
        "mdc-snackbar__dismiss": context === "snackbar:actions",
        "mdc-data-table__pagination-button": context === "data-table:pagination",
        "mdc-data-table__sort-icon-button": context === "data-table:sortable-header-cell",
        "mdc-dialog__close": (context === "dialog:header" || context === "dialog:sheet") && action === "close",
        ...internalClasses
      }),
      style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" "),
      "aria-pressed": !isUninitializedValue(pressed) ? pressed ? "true" : "false" : null,
      "aria-label": pressed ? ariaLabelOn : ariaLabelOff,
      "data-aria-label-on": ariaLabelOn,
      "data-aria-label-off": ariaLabelOff,
      "aria-describedby": ariaDescribedby,
      href
    },
    actionProp,
    internalAttrs,
    restProps,
    {
      onclick: (e) => {
        if (context === "top-app-bar:navigation") {
          dispatch(getElement(), "SMUITopAppBarIconButtonNav");
        }
        restProps.onclick?.(e);
      },
      children: ($$payload2) => {
        $$payload2.out += `<div class="mdc-icon-button__ripple"></div> `;
        children?.($$payload2);
        $$payload2.out += `<!---->`;
        if (touch) {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<div class="mdc-icon-button__touch"></div>`;
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]-->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { pressed, getElement });
  pop();
}
function Drawer($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    variant,
    open = false,
    fixed = true,
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let eventManager = new SvelteEventManager();
  let internalClasses = {};
  setContext("SMUI:list:nav", true);
  setContext("SMUI:list:item:nav", true);
  setContext("SMUI:list:wrapFocus", true);
  onDestroy(() => {
    eventManager.clear();
  });
  function setOpen(value) {
    open = value;
  }
  function isOpen() {
    return open;
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<aside${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-drawer": true,
      "mdc-drawer--dismissible": variant === "dismissible",
      "mdc-drawer--modal": variant === "modal",
      "smui-drawer__absolute": variant === "modal" && !fixed,
      ...internalClasses
    })),
    ...restProps
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></aside>`;
  bind_props($$props, { open, setOpen, isOpen, getElement });
  pop();
}
function Content($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-drawer__content", tag: "div" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Header($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-drawer__header", tag: "div" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Scrim($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    fixed = true,
    component: MyComponent = SmuiElement,
    tag = "div",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  function handleClick(event) {
    dispatch(getElement(), "SMUIDrawerScrimClick", event);
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-drawer-scrim": true,
        "smui-drawer-scrim__absolute": !fixed
      })
    },
    restProps,
    {
      onclick: (e) => {
        handleClick(e);
        restProps.onclick?.(e);
      },
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
function Navbar($$payload, $$props) {
  push();
  var $$store_subs;
  let open = false;
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    const each_array_1 = ensure_array_like(menu);
    Drawer($$payload2, {
      variant: "modal",
      class: "z-[100]",
      get open() {
        return open;
      },
      set open($$value) {
        open = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        Header($$payload3, {
          class: "flex items-center justify-center py-12",
          children: ($$payload4) => {
            Logo($$payload4);
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!----> `;
        Separator($$payload3, {});
        $$payload3.out += `<!----> `;
        Content($$payload3, {
          class: "flex flex-col",
          children: ($$payload4) => {
            List($$payload4, {
              class: "flex-1",
              children: ($$payload5) => {
                const each_array = ensure_array_like(menu);
                $$payload5.out += `<!--[-->`;
                for (let i = 0, $$length = each_array.length; i < $$length; i++) {
                  let { name, link, icon } = each_array[i];
                  const active = store_get($$store_subs ??= {}, "$page", page).url.href.replace(store_get($$store_subs ??= {}, "$page", page).url.origin, "") === link;
                  Item($$payload5, {
                    href: "javascript:void(0)",
                    onclick: () => goto(),
                    activated: active,
                    children: ($$payload6) => {
                      Graphic($$payload6, {
                        class: "material-symbols-outlined",
                        children: ($$payload7) => {
                          $$payload7.out += `<!---->${escape_html(icon)}`;
                        },
                        $$slots: { default: true }
                      });
                      $$payload6.out += `<!----> `;
                      Text($$payload6, {
                        children: ($$payload7) => {
                          $$payload7.out += `<!---->${escape_html(name)}`;
                        },
                        $$slots: { default: true }
                      });
                      $$payload6.out += `<!---->`;
                    },
                    $$slots: { default: true }
                  });
                }
                $$payload5.out += `<!--]--> `;
                Separator($$payload5, {});
                $$payload5.out += `<!----> `;
                Item($$payload5, {
                  href: "javascript:void(0)",
                  onclick: downloadInstaller,
                  children: ($$payload6) => {
                    Graphic($$payload6, {
                      class: "material-symbols-outlined",
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->download`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!----> `;
                    Text($$payload6, {
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->Download`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!---->`;
                  },
                  $$slots: { default: true }
                });
                $$payload5.out += `<!---->`;
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!----> `;
            PurchaseButton($$payload4, {
              context: "drawer",
              containerClass: "mt-auto p-2",
              menuClass: "z-[100]"
            });
            $$payload4.out += `<!---->`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!---->`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    Scrim($$payload2, { fixed: true, class: "z-[80]" });
    $$payload2.out += `<!----> <div class="section-container flex items-center justify-center sticky top-0 z-50 bg-transparent !py-4 pointer-events-none"><div class="transition mx-auto text-white pointer-events-auto"><div${attr("class", `mx-auto ${stringify("bg-teal-950 text-white")} transition backdrop-blur-3xl p-4 px-8 rounded-3xl`)}><div class="flex items-center justify-between flex-row gap-4 lg:gap-12 min-w-48">`;
    Animate($$payload2, {
      children: ($$payload3) => {
        Logo($$payload3);
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="items-center gap-8 hidden lg:flex"><!--[-->`;
    for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
      let { name, link } = each_array_1[i];
      const active = store_get($$store_subs ??= {}, "$page", page).url.href.replace(store_get($$store_subs ??= {}, "$page", page).url.origin, "") === link;
      Animate($$payload2, {
        delay: (i + 1) * 0.1 + "s",
        children: ($$payload3) => {
          Link($$payload3, {
            to: link,
            class: active ? "!text-teal-300" : "",
            children: ($$payload4) => {
              $$payload4.out += `<!---->${escape_html(name)}`;
            },
            $$slots: { default: true }
          });
        },
        $$slots: { default: true }
      });
    }
    $$payload2.out += `<!--]--></div> <div class="flex lg:hidden cursor-pointer">`;
    IconButton($$payload2, {
      class: "material-symbols-outlined",
      onclick: () => open = true,
      children: ($$payload3) => {
        $$payload3.out += `<!---->menu`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div> <div class="hidden lg:flex">`;
    DownloadButton($$payload2, { size: 2 });
    $$payload2.out += `<!----></div></div></div></div></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
function _layout($$payload, $$props) {
  push();
  analytics.page();
  head($$payload, ($$payload2) => {
    $$payload2.out += `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,1,200">`;
  });
  $$payload.out += `<div class="fade-in bg-white">`;
  Navbar($$payload);
  $$payload.out += `<!----> <!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----> `;
  Footer($$payload);
  $$payload.out += `<!----></div>`;
  pop();
}
export {
  _layout as default
};
